import { ComponentProps } from 'react'
// eslint-disable-next-line no-restricted-imports
import * as AriaComponents from 'react-aria-components'
// eslint-disable-next-line no-restricted-imports
import { Button as AriaButton } from 'react-aria-components'

// for customizing particular component example
export const Button = (props: ComponentProps<typeof AriaButton>) => (
  <AriaButton {...props} />
)

export const Autocomplete = AriaComponents.Autocomplete
export const AutocompleteContext = AriaComponents.AutocompleteContext
export const AutocompleteStateContext = AriaComponents.AutocompleteStateContext
export const Breadcrumb = AriaComponents.Breadcrumb
export const Breadcrumbs = AriaComponents.Breadcrumbs
export const BreadcrumbsContext = AriaComponents.BreadcrumbsContext
export const ButtonContext = AriaComponents.ButtonContext
export const Calendar = AriaComponents.Calendar
export const CalendarCell = AriaComponents.CalendarCell
export const CalendarContext = AriaComponents.CalendarContext
export const CalendarGrid = AriaComponents.CalendarGrid
export const CalendarGridBody = AriaComponents.CalendarGridBody
export const CalendarGridHeader = AriaComponents.CalendarGridHeader
export const CalendarHeaderCell = AriaComponents.CalendarHeaderCell
export const CalendarStateContext = AriaComponents.CalendarStateContext
export const Cell = AriaComponents.Cell
export const Checkbox = AriaComponents.Checkbox
export const CheckboxContext = AriaComponents.CheckboxContext
export const CheckboxGroup = AriaComponents.CheckboxGroup
export const CheckboxGroupContext = AriaComponents.CheckboxGroupContext
export const CheckboxGroupStateContext =
  AriaComponents.CheckboxGroupStateContext
export const Collection = AriaComponents.Collection
export const CollectionRendererContext =
  AriaComponents.CollectionRendererContext
export const ColorArea = AriaComponents.ColorArea
export const ColorAreaContext = AriaComponents.ColorAreaContext
export const ColorAreaStateContext = AriaComponents.ColorAreaStateContext
export const ColorField = AriaComponents.ColorField
export const ColorFieldContext = AriaComponents.ColorFieldContext
export const ColorFieldStateContext = AriaComponents.ColorFieldStateContext
export const ColorPicker = AriaComponents.ColorPicker
export const ColorPickerContext = AriaComponents.ColorPickerContext
export const ColorPickerStateContext = AriaComponents.ColorPickerStateContext
export const ColorSlider = AriaComponents.ColorSlider
export const ColorSliderContext = AriaComponents.ColorSliderContext
export const ColorSliderStateContext = AriaComponents.ColorSliderStateContext
export const ColorSwatch = AriaComponents.ColorSwatch
export const ColorSwatchContext = AriaComponents.ColorSwatchContext
export const ColorSwatchPicker = AriaComponents.ColorSwatchPicker
export const ColorSwatchPickerContext = AriaComponents.ColorSwatchPickerContext
export const ColorSwatchPickerItem = AriaComponents.ColorSwatchPickerItem
export const ColorThumb = AriaComponents.ColorThumb
export const ColorWheel = AriaComponents.ColorWheel
export const ColorWheelContext = AriaComponents.ColorWheelContext
export const ColorWheelStateContext = AriaComponents.ColorWheelStateContext
export const ColorWheelTrack = AriaComponents.ColorWheelTrack
export const ColorWheelTrackContext = AriaComponents.ColorWheelTrackContext
export const Column = AriaComponents.Column
export const ColumnResizer = AriaComponents.ColumnResizer
export const ComboBox = AriaComponents.ComboBox
export const ComboBoxContext = AriaComponents.ComboBoxContext
export const ComboBoxStateContext = AriaComponents.ComboBoxStateContext
export const DateField = AriaComponents.DateField
export const DateFieldContext = AriaComponents.DateFieldContext
export const DateFieldStateContext = AriaComponents.DateFieldStateContext
export const DateInput = AriaComponents.DateInput
export const DatePicker = AriaComponents.DatePicker
export const DatePickerContext = AriaComponents.DatePickerContext
export const DatePickerStateContext = AriaComponents.DatePickerStateContext
export const DateRangePicker = AriaComponents.DateRangePicker
export const DateRangePickerContext = AriaComponents.DateRangePickerContext
export const DateRangePickerStateContext =
  AriaComponents.DateRangePickerStateContext
export const DateSegment = AriaComponents.DateSegment
export const DefaultCollectionRenderer =
  AriaComponents.DefaultCollectionRenderer
export const Dialog = AriaComponents.Dialog
export const DialogContext = AriaComponents.DialogContext
export const DialogTrigger = AriaComponents.DialogTrigger
export const Disclosure = AriaComponents.Disclosure
export const DisclosureContext = AriaComponents.DisclosureContext
export const DisclosureGroup = AriaComponents.DisclosureGroup
export const DisclosureGroupStateContext =
  AriaComponents.DisclosureGroupStateContext
export const DisclosurePanel = AriaComponents.DisclosurePanel
export const DisclosureStateContext = AriaComponents.DisclosureStateContext
export const DragAndDropContext = AriaComponents.DragAndDropContext
export const DropIndicator = AriaComponents.DropIndicator
export const DropIndicatorContext = AriaComponents.DropIndicatorContext
export const DropZone = AriaComponents.DropZone
export const DropZoneContext = AriaComponents.DropZoneContext
export const FieldError = AriaComponents.FieldError
export const FieldErrorContext = AriaComponents.FieldErrorContext
export const FileTrigger = AriaComponents.FileTrigger
export const Focusable = AriaComponents.Focusable
export const Form = AriaComponents.Form
export const FormContext = AriaComponents.FormContext
export const FormValidationContext = AriaComponents.FormValidationContext
export const GridLayout = AriaComponents.GridLayout
export const GridList = AriaComponents.GridList
export const GridListContext = AriaComponents.GridListContext
export const GridListItem = AriaComponents.GridListItem
export const Group = AriaComponents.Group
export const GroupContext = AriaComponents.GroupContext
export const Header = AriaComponents.Header
export const HeaderContext = AriaComponents.HeaderContext
export const Heading = AriaComponents.Heading
export const HeadingContext = AriaComponents.HeadingContext
export const I18nProvider = AriaComponents.I18nProvider
export const Input = AriaComponents.Input
export const InputContext = AriaComponents.InputContext
export const Keyboard = AriaComponents.Keyboard
export const KeyboardContext = AriaComponents.KeyboardContext
export const Label = AriaComponents.Label
export const LabelContext = AriaComponents.LabelContext
export const Layout = AriaComponents.Layout
export const LayoutInfo = AriaComponents.LayoutInfo
export const Link = AriaComponents.Link
export const LinkContext = AriaComponents.LinkContext
export const ListBox = AriaComponents.ListBox
export const ListBoxContext = AriaComponents.ListBoxContext
export const ListBoxItem = AriaComponents.ListBoxItem
export const ListBoxSection = AriaComponents.ListBoxSection
export const ListLayout = AriaComponents.ListLayout
export const ListStateContext = AriaComponents.ListStateContext
export const Menu = AriaComponents.Menu
export const MenuContext = AriaComponents.MenuContext
export const MenuItem = AriaComponents.MenuItem
export const MenuSection = AriaComponents.MenuSection
export const MenuStateContext = AriaComponents.MenuStateContext
export const MenuTrigger = AriaComponents.MenuTrigger
export const Meter = AriaComponents.Meter
export const MeterContext = AriaComponents.MeterContext
export const Modal = AriaComponents.Modal
export const ModalContext = AriaComponents.ModalContext
export const ModalOverlay = AriaComponents.ModalOverlay
export const NumberField = AriaComponents.NumberField
export const NumberFieldContext = AriaComponents.NumberFieldContext
export const NumberFieldStateContext = AriaComponents.NumberFieldStateContext
export const OverlayArrow = AriaComponents.OverlayArrow
export const OverlayTriggerStateContext =
  AriaComponents.OverlayTriggerStateContext
export const Point = AriaComponents.Point
export const Popover = AriaComponents.Popover
export const PopoverContext = AriaComponents.PopoverContext
export const Pressable = AriaComponents.Pressable
export const ProgressBar = AriaComponents.ProgressBar
export const ProgressBarContext = AriaComponents.ProgressBarContext
export const Provider = AriaComponents.Provider
export const Radio = AriaComponents.Radio
export const RadioContext = AriaComponents.RadioContext
export const RadioGroup = AriaComponents.RadioGroup
export const RadioGroupContext = AriaComponents.RadioGroupContext
export const RadioGroupStateContext = AriaComponents.RadioGroupStateContext
export const RangeCalendar = AriaComponents.RangeCalendar
export const RangeCalendarContext = AriaComponents.RangeCalendarContext
export const RangeCalendarStateContext =
  AriaComponents.RangeCalendarStateContext
export const Rect = AriaComponents.Rect
export const ResizableTableContainer = AriaComponents.ResizableTableContainer
export const RootMenuTriggerStateContext =
  AriaComponents.RootMenuTriggerStateContext
export const RouterProvider = AriaComponents.RouterProvider
export const Row = AriaComponents.Row
export const SSRProvider = AriaComponents.SSRProvider
export const SearchField = AriaComponents.SearchField
export const SearchFieldContext = AriaComponents.SearchFieldContext
export const Select = AriaComponents.Select
export const SelectContext = AriaComponents.SelectContext
export const SelectStateContext = AriaComponents.SelectStateContext
export const SelectValue = AriaComponents.SelectValue
export const SelectValueContext = AriaComponents.SelectValueContext
export const Separator = AriaComponents.Separator
export const SeparatorContext = AriaComponents.SeparatorContext
export const Size = AriaComponents.Size
export const Slider = AriaComponents.Slider
export const SliderContext = AriaComponents.SliderContext
export const SliderOutput = AriaComponents.SliderOutput
export const SliderOutputContext = AriaComponents.SliderOutputContext
export const SliderStateContext = AriaComponents.SliderStateContext
export const SliderThumb = AriaComponents.SliderThumb
export const SliderTrack = AriaComponents.SliderTrack
export const SliderTrackContext = AriaComponents.SliderTrackContext
export const SubmenuTrigger = AriaComponents.SubmenuTrigger
export const Switch = AriaComponents.Switch
export const SwitchContext = AriaComponents.SwitchContext
export const Tab = AriaComponents.Tab
export const TabList = AriaComponents.TabList
export const TabListStateContext = AriaComponents.TabListStateContext
export const TabPanel = AriaComponents.TabPanel
export const Table = AriaComponents.Table
export const TableBody = AriaComponents.TableBody
export const TableColumnResizeStateContext =
  AriaComponents.TableColumnResizeStateContext
export const TableContext = AriaComponents.TableContext
export const TableHeader = AriaComponents.TableHeader
export const TableLayout = AriaComponents.TableLayout
export const TableStateContext = AriaComponents.TableStateContext
export const Tabs = AriaComponents.Tabs
export const TabsContext = AriaComponents.TabsContext
export const Tag = AriaComponents.Tag
export const TagGroup = AriaComponents.TagGroup
export const TagGroupContext = AriaComponents.TagGroupContext
export const TagList = AriaComponents.TagList
export const TagListContext = AriaComponents.TagListContext
export const Text = AriaComponents.Text
export const TextArea = AriaComponents.TextArea
export const TextAreaContext = AriaComponents.TextAreaContext
export const TextContext = AriaComponents.TextContext
export const TextField = AriaComponents.TextField
export const TextFieldContext = AriaComponents.TextFieldContext
export const TimeField = AriaComponents.TimeField
export const TimeFieldContext = AriaComponents.TimeFieldContext
export const TimeFieldStateContext = AriaComponents.TimeFieldStateContext
export const ToggleButton = AriaComponents.ToggleButton
export const ToggleButtonContext = AriaComponents.ToggleButtonContext
export const ToggleButtonGroup = AriaComponents.ToggleButtonGroup
export const ToggleButtonGroupContext = AriaComponents.ToggleButtonGroupContext
export const ToggleGroupStateContext = AriaComponents.ToggleGroupStateContext
export const Toolbar = AriaComponents.Toolbar
export const ToolbarContext = AriaComponents.ToolbarContext
export const Tooltip = AriaComponents.Tooltip
export const TooltipContext = AriaComponents.TooltipContext
export const TooltipTrigger = AriaComponents.TooltipTrigger
export const TooltipTriggerStateContext =
  AriaComponents.TooltipTriggerStateContext
export const Tree = AriaComponents.Tree
export const TreeContext = AriaComponents.TreeContext
export const TreeItem = AriaComponents.TreeItem
export const TreeItemContent = AriaComponents.TreeItemContent
export const TreeStateContext = AriaComponents.TreeStateContext
export const Virtualizer = AriaComponents.Virtualizer
export const WaterfallLayout = AriaComponents.WaterfallLayout
